import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
} from '@twistopayments/design-system/styles'

const HEADER_SIZE = {
  desktop: size[32],
  mobile: size[24],
}

export const layout = css`
  position: relative;
  display: grid;
  min-height: 100vh;
  grid-template-columns: clamp(360px, 33%, 640px) 1fr;
  grid-template-rows: max-content 1fr max-content;
  grid-template-areas:
    'header content'
    'order-info content'
    'footer content';

  @supports (min-height: 100dvh) {
    min-height: 100dvh;
  }

  ${breakpoint.down('sm')} {
    grid-template-columns: 1fr;
    grid-template-rows: max-content max-content 1fr max-content;
    grid-template-areas:
      'header'
      'order-info'
      'content'
      'footer';
  }
`

export const footer = css`
  grid-area: footer;
  padding: 0 0 ${size[64]} ${size[16]};
  ${breakpoint.down('sm')} {
    display: none;
  }
`

export const orderInfoContainer = css`
  position: relative;
  padding-left: ${size[16]};
  padding-bottom: ${size[16]};

  ${breakpoint.down('sm')} {
    padding-right: ${size[16]};
  }
`

export const orderInfoWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 608px;
  margin: 0 auto;
  grid-area: order-info;

  ${breakpoint.up('lg')} {
    padding-bottom: calc(${HEADER_SIZE.desktop} + ${size[80]} + ${size[40]});
    padding-left: ${size[80]};
    padding-right: ${size[80]};
  }
`

export const root = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const siteIdentifierText = css`
  font-size: ${fontSize.xxs};
`

export const priceText = css`
  margin-top: ${size[8]};

  ${breakpoint.up('md')} {
    margin-top: ${size[16]};
  }
`

export const noticeText = css`
  margin-top: ${size[8]};

  ${breakpoint.up('md')} {
    margin-top: ${size[32]};
  }
`

export const contentContainer = css`
  position: relative;
  height: 100%;
  padding: ${size[16]};
  grid-area: content;
  overflow-y: scroll;

  ${breakpoint.down('sm')} {
    padding: ${size[16]} 0 0 0;
  }

  ${breakpoint.down('lg')} {
    overflow-y: initial;
  }

  ${breakpoint.down('xs')} {
    padding: 0;
  }
`

export const contentBox = (theme: Theme) => css`
  position: relative;
  display: grid;
  grid-auto-flow: row;
  align-items: stretch;
  justify-items: stretch;
  grid-area: content;
  row-gap: ${size[24]};
  grid-template-rows: 1fr;

  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.palette.background.accent};

  min-height: 100%;
  padding: ${size[24]};

  & [data-testid='headline'] {
    margin-top: 0;
  }

  ${breakpoint.down('xs')} {
    padding: 0;
  }

  ${breakpoint.down('sm')} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  ${breakpoint.down('smMd')} {
    & [data-testid='headline'] {
      margin-top: ${size[32]};
    }
  }
`
